<template>
    <div class="login-container">
        <el-form class="card-box login-form" autoComplete="on" :model="ruleForm" :rules="rules" ref="ruleForm"
                 label-position="left">
            <h3 class="title">System Login</h3>
            <el-form-item prop="username" class="item">
                <el-input
                    placeholder="User Name"
                    name="userName"
                    autoComplete="on"
                    v-model="ruleForm.userName">
                    <i slot="prefix" class="el-input__icon"><icon-svg icon-class="user"/></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password" class="item">
                <!--<span class="svg-container">-->
                <!--<icon-svg icon-class="pwd"/>-->
                <!--</span>-->
                <el-input
                    placeholder="Password"
                    name="pwd" :type="isShowPwd ? 'text' : 'password'"
                    @keyup.enter.native="handleLogin"
                    v-model="ruleForm.pwd"
                    autoComplete="on">
                    <i slot="prefix" class="el-input__icon"><icon-svg icon-class="pwd"/></i>
                    <i slot="suffix" class="el-input__icon" @click='isShowPwd = !isShowPwd'><icon-svg icon-class="eye"/></i>
                </el-input>
            </el-form-item>
            <div>
                <el-button type="primary" style="width:100%;margin-bottom:30px;" :loading="loading"
                           @click.native="handleLogin()">Login
                </el-button>
            </div>
            <!-- <div>
                <el-button type="primary" style="width:100%;margin-bottom:30px;"
                           @click='showDialog = true'>
                    Third party login
                </el-button>
            </div> -->
        </el-form>

        <el-dialog title="Third party verification" :visible.sync="showDialog">
            Mailbox login succeeded, please select third-party authentication<br/>
        </el-dialog>

    </div>
</template>

<script>
import {
    userInfo
} from "../../api/auth/login";
export default {
    data() {
        let validatePwd = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please input a password"));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                userName: "",
                pwd: "",
                checked: true
            },
            rules: {
                userName: [
                    { required: true, message: "Please enter login", trigger: "blur" }
                ],
                pwd: [{ validator: validatePwd, trigger: "blur" }]
            },
            isShowPwd: false, // Show password
            loading: false, // login loading
            showDialog: false, // Show dialog
            redirect: null // token url
        };
    },
    methods: {
        handleLogin() {
            var that = this;
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$store.dispatch("loginName", this.ruleForm)
                        .then(response => {
                            this.loading = false;
                            if (response.code) {
//                                this.$message.error(response.message);
                                return;
                            }
                            userInfo({}).then(response => {
                                 if(response.data.authRules.length>1){
                                     var url='';
                                     for(var a=0;a<response.data.authRules.length;a++){
                                         if(response.data.authRules[a] == 'epcData/index'){
                                             url = response.data.authRules[a]
                                         }
                                     }
                                     if(url==''){
                                         this.$message.error('The role does not have EPC permission');
                                         return
                                     }else{
                                        let path = "/epc";
                                        if (that.redirect) {
                                            path = that.redirect;
                                        }
                                        that.$router.push({
                                            path: path
                                        });
                                        // window.location.replace(path);
                                        // that.showDialog = true
                                     }
                                 }else{
                                     if(response.data.authRules.length==1){
                                         if(!response.data.authRules[0]){
                                            this.$message.error('The current user has no permission');
                                            return
                                         }else{
                                             let path = "/epc";
                                            if (that.redirect) {
                                                path = that.redirect;
                                            }
                                            that.$router.push({
                                                path: path
                                            });
                                         }
                                     }

                                    // window.location.replace(path);
                                    // that.showDialog = true
                                 }
                            }).catch(() => {
                                 this.loading = false;
                            });

                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    },
    created() {
        // Copy parameters into query object
        //        let query = this.$route.query;
        //        if (query.redirect) {
        //            // URL Encode
        //            this.redirect = decodeURIComponent(query.redirect);
        //        }
    }
};
</script>

<style type="text/scss" lang="scss">
@import "../../styles/mixin";

$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
    @include relative;
    height: 100%;
    background-color: $bg;
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #293444 inset !important;
        -webkit-text-fill-color: #fff !important;
    }
    .item {
        margin-top: 30px;
        .el-form-item__content {
            display: flex;
            flex-flow: row;
        }
    }
    input {
        background: transparent;
        border: 0;
        -webkit-appearance: none;
        border-radius: 0;
        padding: 0.46rem 0.0666rem 0.16rem 0.2rem;
        color: $light_gray;
        height: 100%;
    }
    .el-input {
        display: inline-block;
    }
    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 0.13333rem;
    }
    .svg-container {
        padding: 0.08rem 0.0666rem 0.08rem 0.2rem;
        color: $dark_gray;
        vertical-align: middle;
        display: inline-block;
        &_login {
            font-size: 20px;
        }
    }
    .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0 auto 0.5333rem auto;
        text-align: center;
        font-weight: bold;
    }
    .login-form {
        @include fxied-center;
        top: 40%;
        width: 25em;
        padding: 1rem 1rem 1rem 1rem;
        box-shadow: 0px 0px 50px 0px #888888;
        border-radius: 3px;
    }
    .el-form-item {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(0, 0, 0, 0.1);
        border-radius: 0.0666rem;
        color: #454545;
    }
    .show-pwd {
        position: absolute;
        right: 0.1333rem;
        top: 0.09333rem;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
    }
    .thirdparty-button {
        /*position: absolute;*/
        /*right: .4666rem;*/
        /*bottom: .37333rem;*/
    }
}
</style>
